import React, { useState } from "react";
import axios from "axios";

const ID_CONNECT = 'identity-connect';
const DEBT_CONNECT = 'debt-connect';
const LOAN_SERVICERS_LOGIN = 'loan-servicers-login';
const LOAN_LIST = 'loan-list';
export const SPINWHEEL_MODULES = {
	ID_CONNECT,
	DEBT_CONNECT,
	LOAN_SERVICERS_LOGIN,
	LOAN_LIST
};

export default function useSpinwheelDim(authToken, setShowManualOptionPopup = () => { }) {
	const [showChooseAccountPopup, setShowChooseAccountPopup] = useState(false);
	const [showSmsVerificationPopup, setShowSmsVerificationPopup] = useState(false);
	const [servicerIds, setServicerIds] = useState([]);
	const [connectionType, setConnectionType] = useState(ID_CONNECT);
	const [verificationData, setVerificationData] = useState(null);

	async function initSpinwheel(forceNew = false, useIdConnect = false) {
		setServicerIds([]);
		setConnectionType(useIdConnect ? ID_CONNECT : LOAN_SERVICERS_LOGIN);
		try {
			const idConnectedResp = await axios.get('/spinwheel/get-identity-connected', {
				headers: { 'Auth-token': authToken }
			});
			if (idConnectedResp?.data?.connected) {
				setShowChooseAccountPopup(true);
				return true;
			}
		} catch (e) {
			console.log(e);
		}
		setShowSmsVerificationPopup(true);
		return false;
	}

	function closeSmsVerificationPopup() {
		setShowSmsVerificationPopup(false);
	}

	async function onSmsVerificationSuccess(data, targetAccountType = 'student') {
		setVerificationData(data);
		setShowSmsVerificationPopup(false);
		if (targetAccountType === 'student') {
			setShowChooseAccountPopup(true);
		}
	}

	async function spinwheelLoanCloseHandler(newAccount, linkedAccounts, newAccountNumberUpdate = null) {
		if (!newAccount) {
			setShowChooseAccountPopup(false);
			return [linkedAccounts, false];
		}
		try {
			const postData = {
				account: newAccount,
				accountNumberUpdate: newAccountNumberUpdate
			};
			if (verificationData) {
				postData.verificationData = verificationData;
				postData.connectionId = verificationData.connectionId;
				postData.networkToken = verificationData.networkToken;
				postData.userId = verificationData.userId;
			}
			const response = await axios.post('/spinwheel/register-account', postData, {
				headers: { 'Auth-token': authToken }
			}).catch(e => console.log(e));

			if (!response?.data?.spinwheel_account_id) {
				setShowChooseAccountPopup(false);
				return [linkedAccounts, false];
			}
			newAccount.spinwheel_account_id = response.data.spinwheel_account_id;
			const accountsChanged = linkedAccounts.filter(acc => acc.spinwheel_account_id === response.data.spinwheel_account_id).length === 0;
			if (accountsChanged) {
				linkedAccounts = [newAccount, ...linkedAccounts];
			}
			setTimeout(() => { document.body.style.overflow = 'scroll'; });
			setShowChooseAccountPopup(false);
			return [linkedAccounts, accountsChanged];
		} catch (e) {
			console.log(e);
			setTimeout(() => { document.body.style.overflow = 'scroll'; });
			setShowChooseAccountPopup(false);
		}
		return [linkedAccounts, false];
	}

	return [
		showChooseAccountPopup,
		initSpinwheel,
		spinwheelLoanCloseHandler,
		servicerIds,
		connectionType,
		showSmsVerificationPopup,
		closeSmsVerificationPopup,
		onSmsVerificationSuccess,
		verificationData,
		setShowChooseAccountPopup,
		setShowSmsVerificationPopup
	];
}
